<template>
  <el-dialog
    :close-on-click-modal="true"
    class="content-card-title"
    :visible.sync="dialogVisible"
    width="450px"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="auto"
      :inline="true"
      :rules="rules"
      label-position="right"
    >
 
    <span class="m-required">评分</span>
    <span class="score-tip">（提交评分后即可申请开票）</span>
   <div class="example1">
      <el-form-item label="平台易用度：" prop="platScore">
        <div style="margin: 10px 0"></div>
        <el-rate v-model="form.platScore" show-text> </el-rate>
      </el-form-item>
      <el-form-item label="出函速度：" prop="etaScore">
        <div style="margin: 10px 0"></div>
        <el-rate v-model="form.etaScore" show-text> </el-rate>
      </el-form-item>
      <el-form-item label="服务态度：" prop="serveScore">
        <div style="margin: 10px 0"></div>
        <el-rate v-model="form.serveScore" show-text> </el-rate>
      </el-form-item>
    </div>
    <span class="m-required2">问题反馈</span>
    <div class="example2">
      <el-form-item label="">
        <el-input
          type="textarea"
          placeholder="请输入您的问题或建议"
          v-model="form.content"
          maxlength="250"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          style="width: 180%"
        >
        </el-input>
      </el-form-item>
    </div>
    <span class="m-required2">联系电话</span>
    <div class="example2">
      <el-form-item label="">
        <el-input style="width: 168%" v-model="form.number"  placeholder="请输入手机号或电话号码"></el-input>
      </el-form-item>
    </div>
      <div style="margin-left: 200px">
        <el-button @click="dialogVisible = false" icon="el-icon-close"
          >取消</el-button
        >
        <el-button type="primary" @click="submit" icon="el-icon-check"
          >提交</el-button
        >
      </div>
      <div
        data-v-4796ed5d=""
        style="width: 0%"
        class="el-divider el-divider--horizontal"
      >
        <!---->
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { submitPerformance } from '@/api/user'
export default {
  name: 'orderScoreDialog',
  props: {
    orderId: {
      type: String,
    },
  },
  created() {},
  data() {
    return {
      dialogVisible: false,
      value: null,
      form: {
        number: '',
        score: null,
        content: '',
        orderId:'',
        platScore:null,
        etaScore:null,
        serveScore:null,
      },
      rules: {
          serveScore: {
          required: true,
          validator: (r, v, callback) => {
            if (this.form.serveScore && this.form.serveScore > 0) {
              callback()
            } else {
              callback(new Error('请选择服务态度分数'))
            }
          },
        },
        etaScore: {
          required: true,
          validator: (r, v, callback) => {
            if (this.form.etaScore && this.form.etaScore > 0) {
              callback()
            } else {
              callback(new Error('请选择出函速度分数'))
            }
          },
        },
        platScore: {
          required: true,
          validator: (r, v, callback) => {
            if (this.form.platScore && this.form.platScore > 0) {
              callback()
            } else {
              callback(new Error('请选择平台易用度分数'))
            }
          },
        },
      },
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.orderId = this.orderId
          submitPerformance(this.form).then((res) => {
            this.dialogVisible = false
            this.$refs.form.resetFields()
            this.$emit('submit')
        })
        } else {
          return false
        }
      })
    },
    uploadSuccess(res) {
      this.form.fileIds.push(res.url)
      this.$refs.form.validateField('fileIds')
    },
  },
}
</script>

<style scoped>
.left-title {
  float: left;
  font-size: 18px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  line-height: 27px;
}
.example1{
	border:1px solid #a1a1a1;
	padding:10px 10px; 
	width:350px;
	border-radius:25px;
  margin-left: 40px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.m-required::before {
  content: '*';
    color: #F56C6C;
    margin-right: 4px;
    margin-left: 40px;
}
.m-required {
  font-size:15px;
  color: #000;
}
.score-tip {
  font-size: 15px;
  color: #fa8c16;
}
.m-required2{
  font-size:15px;
  color: #000;
  margin-left: 40px;
}
.example2{
  margin-left: 27px;

}
.container .el-form .el-form-item {
    width: 100%;
}
</style>
